import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/landing.js';

ReactDOM.render(<App />, document.getElementById('root'));
